export const getSessionsByRotation = (sessions: any[], rotationId: string) =>
  sessions.filter((s) => s.rotation === rotationId);

export const getExplorationsByRotation = (
  explorations: any[],
  sessions: any[],
  rotationIds: string[],
) => {
  if (!rotationIds.length) return explorations;

  const sessionIds = new Set(
    sessions.filter((s) => rotationIds.includes(s.rotation)).map((s) => s._id),
  );
  return explorations.filter((e) => sessionIds.has(e.session));
};

export const getExplorationsBySession = (
  explorations: any[],
  sessions: any[],
  sessionNames: string[],
) => {
  if (!sessionNames.length) return explorations;

  const sessionIds = new Set(
    sessions.filter((s) => sessionNames.includes(s.name)).map((s) => s._id),
  );
  return explorations.filter((e) => sessionIds.has(e.session));
};

export const getExplorationsByTeacher = (
  explorations: any[],
  teachers: string[],
) => {
  if (!teachers.length) return explorations;
  const allowed = new Set(teachers);

  return explorations.filter((e) => {
    if (allowed.has(e.teacher)) return true;
    return (e.coTeachers ?? []).some((id: string) => allowed.has(id));
  });
};

export const getExplorationsByGradeLevel = (
  explorations: any[],
  gradeLevels: number[],
) => {
  if (!gradeLevels.length) return explorations;

  const allowed = new Set(gradeLevels);

  return explorations.filter((e) =>
    (e.gradeLevels ?? []).some((g: number) => allowed.has(g)),
  );
};

export const getExplorationsByPathway = (
  explorations: any[],
  pathways: string[],
) => {
  if (!pathways.length) return explorations;

  const allowed = new Set(pathways);

  return explorations.filter((e) => allowed.has(e.pathway));
};
